import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClientViewModel } from '../../models-views/client.view.model';
import { AppCommon } from '../../providers/app-common';
import { QuickAddService } from '../../services/quick-add.service';
import { VendorViewModel } from '../../models-views/vendor.view.model';

@Component({
  selector: 'app-vendor-add-poc',
  standalone: false,
  templateUrl: './vendor-add-poc.component.html',
  styleUrl: './vendor-add-poc.component.scss'
})
export class VendorAddPocComponent {

  @Input() data: any;
  @Input() vendorID: any;
  @Input() isVisible = false;
  @Input() allPOCData: any[] = [];
  @Input() pocList :any[]=[];
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() closeDrawerData = new EventEmitter<boolean>();
  vendorForm: FormGroup;
  loggedInUser: any
  countryCodeList: any = []

  constructor(private fb: FormBuilder, private message: NzMessageService, private vm: VendorViewModel,
    private quickAddService: QuickAddService,
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.vm.vendorAddPocComponent = this
    this.vendorForm = this.fb.group({
      contact_person: [''],
      phone_number: [''],
      country_code: [''],
      designation: ['', Validators.required],      // MANDATORY
      linkedin: [''],
      email: ['', [Validators.email]]
    });
    this.vm.countryCodeList.subscribe(data => {
      this.countryCodeList = data.results
    })
    this.vm.getCountryCodeList()
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

    if (changes['data']?.currentValue && this.data) {
      let formData = {
        contact_person: changes['data'].currentValue.contact_person,
        phone_number: changes['data'].currentValue.phone_number,
        country_code: changes['data'].currentValue.country_code,
        designation : changes['data'].currentValue.designation,
        // linkedin : changes['data'].currentValue.linkedin,
        email: changes['data'].currentValue.email,
        linkedin: this.stripHttps(changes['data'].currentValue.linkedin)
      }
      this.vendorForm.patchValue(formData)
    }
    this.vendorID = this.data ? this.data.vendor : this.vendorID;
  }

  stripHttps(url: string | null | undefined): string {
    if (!url) return '';
    return url.replace(/^https?:\/\//, ''); // removes http:// or https://
  }


  handleCancel(): void {
    this.isVisible = false;
    this.vendorForm.reset();
    this.closeDrawer.emit(false);
  }


  save(): void {
    if (this.vendorForm.invalid) {
      this.message.error('Please fill all required fields correctly');
      return;
    }

    const formData = { ...this.vendorForm.value };

     if (formData.linkedin && formData.linkedin.trim().length > 0) {
        if (!formData.linkedin.startsWith('http://') && !formData.linkedin.startsWith('https://')) {
          formData.linkedin = 'https://' + formData.linkedin;
        }
      }

    if (this.data && this.vendorID) {
      formData.modified_by = this.loggedInUser.id;
      formData.vendor = this.vendorID;
      this.vm.updatePOC(formData, this.data.id,'vendorAddPocComponent');
    } else if(this.vendorID) {

      formData.created_by = this.loggedInUser.id;
      formData.vendor = this.vendorID;
      // if (!this.allPOCData.some(el => el.type === 1)) {
      //   formData.type = 1;
      // }
       if(this.pocList && this.pocList.length > 0){
        this.pocList.map((ele:any) => {
          if(!ele.is_primary){
            formData.type = true;
          }
        })
      } else {
         formData.type = true;
      }

      this.vm.createPOC(formData);
    } else{
      this.pocCreated()
    }
  }


  pocUpdated(){
    let d = this.vendorForm.value
    d['id'] = this.data.id
    this.closeDrawerData.emit(d)
    this.isVisible = false;
    this.vendorForm.reset();
    this.quickAddService.refreshData.next(true)
    this.closeDrawer.emit(true);
  }

  pocCreated() {
    this.closeDrawerData.emit(this.vendorForm.value)
    this.isVisible = false;
    this.vendorForm.reset();
    this.quickAddService.refreshData.next(true);
    this.closeDrawer.emit(true);
  }

}
